import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { UpdateBanner } from './components/UpdateBanner';
import './index.css';

/*
 * ★ `/station` 跳到 `/station.html`。
 *
 *   浏览器打印台是 `public/station.html` 这个独立静态页,而设置页里
 *   写给店里人的地址是 `{当前网址}/station`(短、好念、好写在纸上)。
 *   两者对不上:`/station` 会落到 SPA 的兜底路由,于是**打开的是管理端本身** ——
 *   人以为自己开错了浏览器,或者以为打印台坏了。
 *
 *   改说明文字是不够的:那个地址已经被念过、写过、存过书签了。
 *   所以这里留一个跳转,旧地址照样能到。
 *
 *   放在渲染之前:先跳走就不会闪一下管理端的界面。
 */
if (location.pathname === '/station' || location.pathname === '/station/') {
  location.replace('/station.html' + location.search + location.hash);
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
      {/* 有新版本的提示条 —— 挂在最外层,登录页、改密码页也要看得到 */}
      <UpdateBanner />
    </StrictMode>,
  );
}
